<script lang="ts">
    export let result: any;

    let hideSteps = true;
</script>

<div class="container">
    <div>
        <span>{result.name}</span>
        <span>{result.result}</span>
        <button on:click={() => hideSteps = !hideSteps}>Show/Hide</button>
    </div>

    {#if !hideSteps}
    {#each result.steps as step}
    <div>
        <span>{step.name}</span>
        <span>{step.guard_result}</span>
        <span>{step.result}</span>
        <span>{step.output}</span>
    </div>
    {/each}
    {/if}
</div>